import { render, staticRenderFns } from "./SmsAddContactToGroupDialog.vue?vue&type=template&id=2489eab6&"
import script from "./SmsAddContactToGroupDialog.vue?vue&type=script&lang=js&"
export * from "./SmsAddContactToGroupDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports